import api from 'api/axios';
import { Integration } from 'views/integrations/types';

export interface AgentIntegration extends Integration {
  agent_integration_id: string;
}

export const getAgentIntegrations = async (agentId: string) => {
  const response = await api({
    url: `/agents/${agentId}/integrations`,
    method: 'GET',
  });
  return response.data as AgentIntegration[];
};

export const updateAgentIntegrations = async (
  agentId: string,
  integration_data_ids: string[],
) => {
  const response = await api({
    url: `/agents/${agentId}/integrations`,
    method: 'POST',
    data: { integration_data_ids },
  });
  return response.data;
};

export const deleteAgentIntegration = async (
  agentId: string,
  integrationId: string,
) => {
  const response = await api({
    url: `/agents/${agentId}/integrations/${integrationId}`,
    method: 'DELETE',
  });
  return response.data;
}; 